import {
  type OnboardingStepContentProps,
  OnboardingStepWrapper,
  type OnboardingStepWrapperProps,
} from "../OnboardingStepWrapper";
import { RoleStepContent } from "./RoleStepContent";

export function RoleStep(
  props: Pick<OnboardingStepWrapperProps, "worker" | "progress" | "onBack" | "onNext" | "stage">
) {
  const { worker, progress, onBack, onNext, stage } = props;

  const stepProps = {
    worker,
    progress,
    stage,
    onNext,
    onBack,
  };

  return (
    <OnboardingStepWrapper
      {...stepProps}
      render={(props: OnboardingStepContentProps) => <RoleStepContent {...props} />}
    />
  );
}
